import { FieldPath, UseFormReturn } from 'react-hook-form';

import { AllEnums, Enum } from '~/data/enums';
import { LegalEntity, getCountryByLegalEntity } from '~/data/legalEntity';
import { filterActiveEnumsByCountryAndOrgUnits } from '~/utils/helper';

import { OverlappingEmpForm } from './hooks/useOverlappingEmploymentForm';

type Field = {
  name: string;
  enum: Enum[];
};

type FieldNames =
  | 'overlappingEmployment.basicData.fInternalPositionPosition'
  | 'overlappingEmployment.basicData.fEmplDetailStatus'
  | 'overlappingEmployment.employmentDetails.fEmplDetailJobGrade'
  | 'overlappingEmployment.basicData.fEmplFixedTermReason'
  | 'overlappingEmployment.basicData.fEmplTerminationReason';

export const resetEnumsFormValues = (
  legalEntityValue: string | undefined,
  organizationUnitValue: number,
  allEnums: AllEnums,
  formActions: UseFormReturn<OverlappingEmpForm>,
  legalEntities: LegalEntity[],
) => {
  if (!legalEntityValue) return;

  const dataFields = [
    {
      name: 'overlappingEmployment.basicData.fInternalPositionPosition',
      enum: allEnums['EMPLOYEE_POSITION'],
    },
    {
      name: 'overlappingEmployment.basicData.fEmplDetailStatus',
      enum: allEnums['EMPLOYMENT_STATUS'],
    },
    {
      name: 'overlappingEmployment.employmentDetails.fEmplDetailJobGrade',
      enum: allEnums['JOB_GRADE'],
    },
    {
      name: 'overlappingEmployment.basicData.fEmplFixedTermReason',
      enum: allEnums['EMPL_FIXED_TERM_REASON'],
    },
    {
      name: 'overlappingEmployment.basicData.fEmplTerminationReason',
      enum: allEnums['EMPL_TERMINATION_REASON'],
    },
  ] as Field[];

  const { getValues, setValue } = formActions;

  dataFields.forEach((field) => {
    const filteredOptions = filterActiveEnumsByCountryAndOrgUnits(
      field.enum,
      getCountryByLegalEntity(+legalEntityValue, legalEntities),
      organizationUnitValue,
    );

    if (
      !filteredOptions.find(
        (o) => o?.code === getValues(field.name as FieldNames),
      )
    ) {
      setValue(field.name as FieldPath<OverlappingEmpForm>, '');
    }
  });
};
